import files from './files'
import meetingAttendees from './meetingAttendees'
import messages from './messages'

export default [messages, meetingAttendees, files]
